import { Menu, UserLevel } from '@/types';
import { notificationsMenu } from './state';
import { menu as user } from './user';

export const menu: Menu = {
  text: 'Admin',
  menu_width: 220,
  menu: [
    user,
    {
      text: 'Notifications',
      click: () => { notificationsMenu.value = true; },
    },
  ],
  disallowed: [
    UserLevel.Supervisor,
    UserLevel.Scorer,
    UserLevel.Annotator,
    UserLevel.User,
    UserLevel.Userhigh,
  ],
};
